import React from 'react'
import { Customizations } from 'models/schema'
import VehicleSheetLinesGroup from '../VehicleSheetLinesGroup'

const VehicleSheetSectionCondition = () => {
  const pricingItems: (keyof Customizations)[] = [
    'providedFRE',
    'reserveTTCHF',
    'estimationApporteur',
    'coteArgusKm',
    'coteArgusPriceDate',
    'coteMarche',
  ]
  const stateItems: (keyof Customizations)[] = [
    'mileage',
    'auctionStatus',
    'administrativeStatus',
    'noteExt',
    'noteInt',
    'noteCT',
    'noteBilanExpert',
  ]

  return (
    <footer className="vehicle-sheet__financial-grid">
      <section className="vehicle-sheet-card vehicle-sheet__pricing">
        <h2 className="vehicle-sheet__section-title">Pricing</h2>
        <VehicleSheetLinesGroup
          arrayOfKeys={pricingItems}
          className="vehicle-sheet__pricing-items"
        />
      </section>
      <section className="vehicle-sheet-card vehicle-sheet__state">
        <h2 className="vehicle-sheet__section-title">État</h2>
        <VehicleSheetLinesGroup
          arrayOfKeys={stateItems}
          className="vehicle-sheet__state-items"
        />
      </section>
    </footer>
  )
}

export default VehicleSheetSectionCondition
